
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-transform-demo-plugin-transform-resizing","docs-tutorial-plugins-transform-demo-plugin-transform-rotating"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/transform.zh.md?type=demo')
};